import { Field, FieldProps } from "formik";
import { FormControl, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
// import { BaseFieldProps } from "../Types/fields.types";

type FormikDatePickerProps =  {
  disabled?: boolean;
};

export default function LocalizateDatePicker({
  name,
  label,
  disabled = false,
  ...rest
}: FormikDatePickerProps) {
  return (
    <Field name={name}>
      {({ form, field, meta }: FieldProps) => {
        const hasError = meta.touched && Boolean(meta.error);

        return (
          <FormControl sx={{ width: '100%', p: '7px' }}>
            <DatePicker
              {...rest}
              label={label}
              disabled={disabled}
              value={field.value ? dayjs(field.value) : null}  // ← null به‌جای dayjs()
              onChange={(newValue: Dayjs | null) => {
                form.setFieldValue(
                  name,
                  newValue && newValue.isValid()
                    ? newValue.toISOString()  // ← به‌جای _d
                    : null
                );
                form.setFieldTouched(name, true);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  fullWidth
                  error={hasError}
                  helperText={hasError ? meta.error : ''}
                />
              )}
            />
          </FormControl>
        );
      }}
    </Field>
  );
}